import React from "react";

function NotFound() {
  return <div className="text-center">Not Found</div>;
}

export default NotFound;
